<template>
  <div class="wrapper" id="default-wrapper">
    <div style="background: black;width: 100%;height: 100%;"></div>
  </div>
</template>
<script>

import BaseFormLoading from './base/BaseFormLoading'

export default {
  name: 'Off',
  components: {BaseFormLoading},
  data: function () {
    return {
      loading: false,
    }
  },
  computed: {},
  created() {
  },
  mounted() {

  },
  methods: {
  },
  watch: {

  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>
<style>
#default-wrapper, #default-wrapper iframe {
  width: 100%;
  height: 100vh;
}

#default-wrapper {
  overflow: hidden;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Off.vue